import { useState } from 'react';
import { NavLink, Link, Outlet } from 'react-router-dom';

const NAV = [
    { to: '/academic-writings', label: 'Writing' },
    { to: '/music', label: 'Music' },
    { to: '/little-things', label: 'Little Things' },
    { to: '/photos', label: 'The Album' },
    { to: '/headspace', label: 'Headspace' },
];

export default function Layout() {
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);

    return (
        <>
            <header className="site-header">
                <div className="site-header-inner">
                    <Link to="/" className="site-brand" onClick={close}>
                        A Collection of Thoughts
                    </Link>

                    <button
                        className="site-nav-toggle"
                        aria-label="Toggle navigation"
                        aria-expanded={open}
                        onClick={() => setOpen((o) => !o)}
                    >
                        <span /><span /><span />
                    </button>

                    <nav className={`site-nav ${open ? 'is-open' : ''}`}>
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                onClick={close}
                                className={({ isActive }) =>
                                    `site-nav-link ${isActive ? 'is-active' : ''}`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
            </header>

            <Outlet />

            <footer className="site-footer">
                <p>© {new Date().getFullYear()} (Pol)aris • Made With Love</p>
            </footer>
        </>
    );
}